import {Action, GuestInfoState, PatchGuestInfoType} from './types'

export const patchGuestInfo: PatchGuestInfoType = {
    country: (value: string) => ({
        type: 'patch-country',
        payload: value
    }),
    telephone: (value: string) => ({
        type: 'patch-telephone',
        payload: value
    }),
    customerNumber: (value: string) => ({
        type: 'patch-customerNumber',
        payload: value
    }),
    email: (value: string) => ({
        type: 'patch-email',
        payload: value
    })
}

const guestInfoReducer: React.Reducer<GuestInfoState, Action> = (state, action) => {
    switch (action.type) {
        case 'patch-country':
            return {...state, country: action.payload}
        case 'patch-telephone':
            return {...state, telephone: action.payload}
        case 'patch-customerNumber':
            return {...state, customerNumber: action.payload}
        case 'patch-email':
            return {...state, email: action.payload}
        default:
            return state
    }
}

export default guestInfoReducer
